import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import SyncIcon from "@mui/icons-material/Sync";
import DrawerAppBar from "./Drawer";
import { matchPath, useLocation } from "react-router-dom";
import Button from "@mui/material/Button";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { isMobile } from "../helpers/mobile";

export default function AppTopBar(props: {
  darkMode: boolean;
  setDarkMode: (mode: boolean) => void;
}) {
  const { t } = useTranslation("topBar");
  const { darkMode, setDarkMode } = props;
  // Subscribe to the router location so the bar re-renders on client-side
  // navigation. Reading window.location.pathname directly is non-reactive: the
  // bar (and its logout drawer) would not recover after a redirect, which is how
  // a route change shipped over the air left drivers with no header / no logout.
  const { pathname } = useLocation();
  const [mobileOpen, setMobileOpen] = useState(false);
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  if (pathname === "/") return null;

  const onRefreshButtonClick = () => {
    window.location.reload();
  };

  const authPages = matchPath({ path: "login" }, pathname);

  return (
    <Box sx={{ flexGrow: 1 }}>
      {!authPages && (
        <AppBar position="static">
          <Toolbar>
            {isMobile && (
              <Box
                sx={{
                  position: "absolute",
                  top: "calc(-1*env(safe-area-inset-top))",
                  left: 0,
                  right: 0,
                  height: "env(safe-area-inset-top)",
                  backgroundColor: "#4F76BA",
                }}
              ></Box>
            )}

            <Box sx={{ flexGrow: 1, alignSelf: "center" }}>
              <Button
                onClick={onRefreshButtonClick}
                variant="outlined"
                startIcon={<SyncIcon />}
                sx={{
                  color: "white",
                  borderColor: "white",
                }}
              >
                {t("update")}
              </Button>
            </Box>

            <IconButton
              color="inherit"
              edge="start"
              onClick={handleDrawerToggle}
            >
              <MenuIcon />
            </IconButton>
            <DrawerAppBar
              handleDrawerToggle={handleDrawerToggle}
              mobileOpen={mobileOpen}
              darkMode={darkMode}
              setDarkMode={setDarkMode}
            />
          </Toolbar>
        </AppBar>
      )}
    </Box>
  );
}
